import { getRoomById, getRoomsName, buildTeachersStr, getGroupById, getTeacherById, getClassHoursById, getSubjectName, getHighestHour } from './TimeTableHelpers'


export const getDailyChangesArray = (context, count) => {

    let HighestHour = getHighestHour(context.state.ttGroups)
    let changes = []
    let change = {}

    /*
    for(let b = 0; b <= HighestHour; b++){
        changes[b] = []
        for(let i = 0; i < context.state.classes.length; i++){
            
            if(context.state.classes[i]){  
                
                if(change = getChangeByDateTime(context,context.state.classes[i]._id,b) ){
                    changes[b][i] = change
                } else{
                    changes[b][i] = {} 
                }
                    
            }
            
        }
    }
    */
    let changesGroup = []
    let currentLesson
    let currFromGroup
    let z = 0
    for (let i = 0; i < context.state.classes.length; i++) {

        if (i % count === 0)
            z++
        if (!changesGroup[z])
            changesGroup[z] = []

        for (let b = 0; b <= HighestHour; b++) {
            if (!changesGroup[z][b])
                changesGroup[z][b] = []

            if (!changesGroup[z][b][i])
                changesGroup[z][b][i] = []




            currentLesson = getLessonByIdToday(context, context.state.classes[i]._id, b)
            //change = getChangeByDateTime(context,context.state.classes[i]._id,b)


            if (currentLesson) {
                changesGroup[z][b][i].push(currentLesson)
            } else {
                changesGroup[z][b][i].push({})
            }







        }


    }
    //console.log(changesGroup)   
    return changesGroup
}

export function getLessonByIdToday(context, classId, hour) {
    let todayDay = context.state.daySelected
    let currGroup
    let lessonInfo
    let lessonsToReturn = []
    let change
    let changeBuild
    let changeInsert
    let ttGroup
    let currGroupInsert
    let timeDictonary
    if (context.state.useSlotLabels) {
        timeDictonary = getClassHoursById(context.state)
    }

    let lessonByTime = context.state.ttGroups.filter((ttGroup) => {
        return ttGroup.day === todayDay && ttGroup.slot === hour
    })


    changeInsert = getChangeInsert(context, todayDay, hour, classId)

    if (changeInsert[0]) {


        //console.log(hour)
        //console.log(changeInsert[0].ttGroup_id)
        ttGroup = getGroupById(changeInsert[0].ttGroup_id, context.state.ttGroups)
        currGroupInsert = getGroupById(ttGroup[0].group_id, context.state.groups)[0]
        let currentClass = getRoomById(ttGroup.room_id, context.state.rooms) ? getRoomById(ttGroup.room_id, context.state.rooms) : []

        lessonInfo = {
            teachers: buildTeachersStr(
                context.state.teachers,
                currGroupInsert.teachers,
                changeInsert[0],
                context.state.currentScreen
            ),
            subject: getSubjectName(
                context.state.subjects,
                currGroupInsert.subject
            ),
            room_name: getRoomsName(currentClass),
        }
        changeInsert[0]["day"] = context.state.daysOfTheWeek[ttGroup[0].day]
        changeInsert[0]["hour"] = timeDictonary ? timeDictonary[ttGroup[0].slot].start : (ttGroup[0].slot + context.state.firstHour)

        lessonsToReturn.push({ ...lessonInfo, ...changeInsert[0] })
        //console.log(lessonsToReturn)
    }


    lessonByTime.forEach((lesson) => {
        changeInsert = ""
        currGroup = getGroupById(lesson.group_id, context.state.groups)


        currGroup.forEach((group) => {
            //console.log(group)
            change = getChange(lesson._id, context)

            if (change[0] && (change[0].ttGroup_id === lesson._id)) {
                //console.log(change)
                changeBuild = buildChange(context, change[0], [lesson], currGroup[0])
            } else {
                changeBuild = ""
            }


            let currentClass = getRoomById(lesson.room_id, context.state.rooms) ? getRoomById(lesson.room_id, context.state.rooms) : []

            if (group && group.classes.includes(classId)) {
                lessonInfo = {
                    teachers: buildTeachersStr(
                        context.state.teachers,
                        currGroup[0].teachers,
                        changeBuild,
                        context.state.currentScreen
                    ),
                    subject: getSubjectName(
                        context.state.subjects,
                        currGroup[0].subject
                    ),
                    room_name: getRoomsName(currentClass),
                }

                lessonsToReturn.push({ ...lessonInfo, ...changeBuild })
            }
        })

    })





    //console.log(lessonsToReturn)
    return lessonsToReturn

}

const getChangeInsert = (context, day, hour, classId) => {
    let ttGroup
    let currGroup
    //hour = context.state.firstHour ? hour + context.state.firstDay : hour 
    if (context.state.ttSubjects) {
        return context.state.ttSubjects.filter((change) => {
            ttGroup = getGroupById(change.ttGroup_id, context.state.ttGroups)
            currGroup = getGroupById(ttGroup[0].group_id, context.state.groups)[0]

            return change.xDay === day && change.xSlot === hour && currGroup.classes.includes(classId)
        })
    }
}

const getChange = (groupId, context) => {
    if (context.state.ttSubjects) {
        return context.state.ttSubjects.filter((change) => {
            return change.ttGroup_id === groupId
        })
    }
}

const getChangeByDateTime = (context, classId, hour) => {



    /*
    let ttGroup
    let currGroup
    let dateObj = new Date()
    let todayDay = dateObj.getDay()
    let changeToReturn
    let buildChangeInfo
    if(context.state.ttSubjects){
        context.state.ttSubjects.forEach((change,index) => {
            ttGroup = getGroupById(change.ttGroup_id,context.state.ttGroups);
            
            if(ttGroup[0].day === todayDay && ttGroup[0].slot === hour && ttGroup[0]._id === change.ttGroup_id){
                currGroup = getGroupById(ttGroup[0].group_id,context.state.groups)[0]
                console.log(ttGroup[0]._id,change.ttGroup_id)
                if(currGroup && ttGroup[0]._id === change.ttGroup_id){
                    //console.log(currGroup)
                   
                    if(currGroup.classes[0] === classId){ 
                        changeToReturn  = buildChange(context,change,ttGroup,currGroup)
                    }
                        
                }
            } else if(change.xDay === todayDay && change.xSlot === hour){
                ttGroup = getGroupById(change.ttGroup_id,context.state.ttGroups)
                currGroup = getGroupById(ttGroup[0].group_id,context.state.groups)[0]
                buildChangeInfo  = buildChange(context,change,ttGroup,currGroup)
                //changeToReturn = {...buildChangeInfo,...currGroup}    
                   
            }         
            
            
        })
    }
    
    return changeToReturn
    */
}

const buildChange = (context, change, ttGroup, currGroup) => {
    let currentChange = {}
    let timeDictonary
    if (context.state.useSlotLabels) {
        timeDictonary = getClassHoursById(context.state)
    }

    currentChange["day"] = context.state.daysOfTheWeek[ttGroup[0].day]
    currentChange["hour"] = timeDictonary ? timeDictonary[ttGroup[0].slot].start : (ttGroup[0].slot + context.state.firstHour)
    if (currGroup) {
        let currentClass = getClassById(context.state.classes, currGroup.classes[0])
        currentChange["current_class"] = currentClass
    }



    if (change.voidTeachers) {
        change.voidTeachers.forEach((teacher, index) => {
            let currentTeacherOut = getTeacherById(context.state.teachers, teacher)[0]

            currentChange["teacher_out"] = currentTeacherOut.name;
            if (change.addTeachers) {
                //console.log(context.state.teachers,change.addTeachers[0]._id)
                let currentTeacherIn = getTeacherById(context.state.teachers, change.addTeachers[index]._id)[0]
                if (currentTeacherIn) {
                    currentChange["teacher_in"] = currentTeacherIn.name
                }
            }



        })


    } else if (change.xDay) {

        let newHour = change.xSlot
        let newDay = change.xDay

        currentChange["newDay"] = context.state.daysOfTheWeek[newDay]
        currentChange["newHour"] = timeDictonary ? timeDictonary[newHour].start : (newHour + context.state.firstHour)


        currentChange["subject"] = getSubjectName(context.state.subjects, currGroup.subject)

    } else if (change.voidReason) {
        currentChange["void_reason"] = change.voidReason
        currentChange["subject"] = getSubjectName(context.state.subjects, currGroup.subject)

    }
    return currentChange
}

export const getDailyChanges = (context) => {
    let todayDay = context.state.daySelected
    let group
    let changes = []
    let ttGroup
    let timeDictonary
    let box_i = 0;
    let box = 0;
    let currentChange

    const currentUrl = new URL(window.location)
    const count = currentUrl.searchParams.get("count")
        ? currentUrl.searchParams.get("count")
        : 5


    if (context.state.ttSubjects) {
        context.state.ttSubjects.forEach((change, index) => {
            ttGroup = getGroupById(change.ttGroup_id, context.state.ttGroups);
            if (ttGroup[0].day !== todayDay)
                return

            if (box_i % count === 0 && box_i !== 0) {
                box++
            }

            //console.log(ttGroup[0].slot)
            let currGroup = getGroupById(ttGroup[0].group_id, context.state.groups)[0]

            currentChange = buildChange(context, change, ttGroup, currGroup)

            //let currentTeacher = getTeacherById(context.state.teachers,group[0])
            if (!changes[box]) {
                changes[box] = []
            }
            //console.log(box)
            changes[box].push(currentChange)


            box_i++
        });
        //console.log(changes)
    }
    return changes.sort(compare);
}

export const getClassById = (classes, class_id) => {
    let currClass = classes.filter((classFilter) => {
        return classFilter._id === class_id
    })
    //console.log(currSubject)
    if (currClass.length > 0) {
        return currClass[0].name
    }
    return '';


}

export const splitChangesToGroup = (arr, count) => {
    //console.log(arr.length)
    let temparray = []
    let z = 0
    //console.log(arr.length)
    for (let i = 0; i < arr.length; i += count) {

        //console.log(arr.slice(i,i+count))
        temparray[z] = arr.slice(i, i + count);
        // do whatever
        z++
    }
    //console.log(temparray)
    return temparray
}

function compare(a, b) {
    if (a.hour < b.hour) {
        return -1;
    }
    if (a.hour > b.hour) {
        return 1;
    }
    return 0;
}

